import React from 'react'
import { Icon, View } from '@/components'
import { createStyles } from '@codeleap/styles'
import { useMessageContext } from 'stream-chat-react'
import { Chat, theme } from '@/config'

export const MessagePin = () => {
  const { message } = useMessageContext()
  const chatUser = Chat.Store.useUser()
  const isMyMessage = message?.user?.id === chatUser?.id

  const styles = isMyMessage ? myMessageStyles : otherMessageStyles

  return (
    <View style={styles.wrapper}>
      <Icon name='pin-02-filled' size={theme.values.iconSize[1]} style={[styles.icon]} />
    </View>
  )
}

const myMessageStyles = createStyles(theme => ({
  wrapper: {
    position: 'absolute',
    top: -theme.spacing.value(0.5),
    left: 'auto',
    right: -theme.spacing.value(1.5),
    boxShadow: theme.effects.light.boxShadow,
    borderRadius: theme.radius.infinite,
    backgroundColor: theme.baseColors.primarySolid500,
    width: theme.size.medium,
    height: theme.size.medium,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 5,
  },
  icon: {
    transform: 'scaleX(-1)',
    color: theme.baseColors.primarySolid50,
    strokeWidth: 0,
  },
}))

const otherMessageStyles = createStyles(theme => ({
  wrapper: {
    position: 'absolute',
    top: 0,
    left: -theme.spacing.value(1.5),
    backgroundColor: theme.baseColors.primarySolid50,
    width: theme.size.medium,
    height: theme.size.medium,
    display: 'flex',
    alignItems: 'center',
    boxShadow: theme.effects.light.boxShadow,
    justifyContent: 'center',
    borderRadius: theme.radius.infinite,
    zIndex: 5,
  },

  icon: {
    transform: 'scaleX(-1) rotate(90deg)',
    color: theme.baseColors.neutralBlackTransparent500,
    strokeWidth: 0,
  },
}))
